import { FC, useEffect, useMemo, useState } from 'react';

import {
  combineURL,
  EllipsisSpan,
  Table,
  usePaging,
  Paging,
  useBreadcrumbRoutes,
  Button,
  Select,
  Form,
  Input,
  Modal,
  Wrapper,
} from '@maxtropy/components';

import BsaSteps from '../BsaSteps';
import BsaPageHeader from '../BsaPageHeader';

import { Space, Row, Col, Spin } from 'antd';

import styles from './index.module.scss';
import { useParams } from 'react-router-dom';
import { BsaComponentsProps, getNext, getPrevious } from '../../factory';
import { BsaType } from '../../../../api/constans';
import {
  BsaDeviceTemplateRequest,
  createPackDevice,
  DeviceTreeProps,
  getDeviceTypeTree,
  packStatusCheck,
  submitPackDevice,
} from '../../../../api/device';
import { debounce } from 'lodash-es';
import { getModel, ModelResponse } from '../../../../api/model';
import classNames from 'classnames';
import { PackDevice } from '../../../../api/entity';
import { getDraft, getPackDevicePage, PackDeviceRequest, saveDraft } from '../../../../api/bsa';
import { BSAStatus, DeviceStatus, DeviceStatusDisplay, ProcessStatusEnum } from '../../../../api/type';
import { padStart } from '../../utils';

const columns = [
  {
    title: '设备编号',
    dataIndex: 'deviceCode',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: 'PCS编号',
    dataIndex: 'pcsSequence',
    render: (v: number) => <EllipsisSpan value={padStart(v)} />,
  },
  {
    title: '电池堆编号',
    dataIndex: 'stackSequence',
    render: (v: number) => <EllipsisSpan value={padStart(v)} />,
  },
  {
    title: '电池簇编号',
    dataIndex: 'rackSequence',
    render: (v: number) => <EllipsisSpan value={padStart(v)} />,
  },
  {
    title: '电池簇组内编号',
    dataIndex: 'packSequence',
    render: (v: number) => <EllipsisSpan value={padStart(v)} />,
  },
  {
    title: '类目',
    dataIndex: 'typeName',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '型号',
    dataIndex: 'modelName',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '电池组能量',
    dataIndex: 'energy',
    ellipsis: { showTitle: true },
    render: (v: string, record: PackDevice) => (
      <EllipsisSpan value={v ? `${v ?? ''} ${record.energyUnit ?? ''}` : undefined} />
    ),
  },
  {
    title: '额定电压',
    dataIndex: 'voltage',
    ellipsis: { showTitle: true },
    render: (v: string, record: PackDevice) => (
      <EllipsisSpan value={v ? `${v ?? ''} ${record.voltageUnit ?? ''}` : undefined} />
    ),
  },
  {
    title: '设备状态',
    dataIndex: 'deviceStatus',
    ellipsis: { showTitle: true },
    render: (value: DeviceStatus) => {
      return <EllipsisSpan value={DeviceStatusDisplay[value]} />;
    },
  },
  {
    title: '操作',
    width: 180,
    fixed: 'right' as const,
    render: (v: undefined, record: PackDevice) => (
      <a
        target="_blank"
        href={combineURL(window.IOTPLATFORMORIGIN, `/device/manage/device/${record.deviceId}/detail`)}
        rel="noreferrer"
      >
        查看详情
      </a>
    ),
  },
];

export const formatTreeData = (tree: DeviceTreeProps[]) => {
  let res: DeviceTreeProps[] = [];
  tree.forEach(i => {
    if (i.name === '储能电池组件') {
      res = res.concat(i.children ?? []);
    }
  });
  return res.filter(i => i.name.includes('电池组'));
};

const formLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 22 },
};

const routes = [{ name: `电池组设置` }];

type SerachParams = Partial<Omit<PackDeviceRequest, 'count' | 'offset' | 'bsaId'>>;

const BsaPack: FC<BsaComponentsProps> = ({
  typeList,
  status,
  disabled,
  foucsType,
  currentType,
  changeType,
  updateFn,
}) => {
  const { id } = useParams<{ id: string }>();

  const routesContext = useBreadcrumbRoutes();

  // const [updateState, update] = useUpdate();

  const [loading, setLoading] = useState<boolean>(false);
  const [tableLoading, setTableLoading] = useState<boolean>(false);

  const [form] = Form.useForm();

  const pagingInfo = usePaging(100);
  const { pageOffset, pageSize, setTotalCount } = pagingInfo;

  const [search, setSearch] = useState<SerachParams>();

  const isInit = useMemo(() => {
    return (typeList ?? []).includes(BsaType.PACK_DEVICE_CREATE);
  }, [typeList]);

  // const isDeviceCreated = useMemo(() => {
  //   return currentType === BsaType.PACK_DEVICE_CREATED
  // }, [currentType])

  const isComplete = useMemo(() => {
    return (typeList ?? []).includes(BsaType.PACK_DEVICE_COMPLETED);
  }, [typeList]);

  /** complete */

  const [packs, setPacks] = useState<PackDevice[]>([]);

  useEffect(() => {
    if (id) {
      if (isComplete || currentType === BsaType.PACK_DEVICE_CREATED) {
        setTableLoading(true);
        getPackDevicePage(Number(id), {
          ...(search ?? {}),
          size: pageSize,
          page: pageOffset,
        }).then(res => {
          setPacks(res.list);
          setTotalCount(res.total);
          setTableLoading(false);
        });
      }
    }
  }, [id, isComplete, search, pageSize, pageOffset, setTotalCount, currentType]);

  useEffect(() => {
    if (id) {
      if (currentType === BsaType.PACK_DEVICE_CREATE) {
        // 未完成，查看是否有草稿
        getDraft(id).then(draft => {
          const content: Partial<Omit<BsaDeviceTemplateRequest, 'bsaId'>> = draft.content
            ? JSON.parse(draft.content)
            : undefined;
          if (content) {
            form.setFieldsValue({
              deviceTypeId: content.deviceTypeId,
              modelName: content.modelName,
            });
            if (content.deviceTypeId) {
              setDeviceType(content.deviceTypeId);
            }
          }
        });
      }
    }
  }, [id, currentType, form]);

  /** complete */

  /** init form */

  const [deviceTypes, setDeviceTypes] = useState<DeviceTreeProps[]>();

  useEffect(() => {
    getDeviceTypeTree().then(res => {
      setDeviceTypes(formatTreeData(res));
    });
  }, []);

  const [deviceType, setDeviceType] = useState<number>();

  const [model, setModel] = useState<ModelResponse[]>([]);

  useEffect(() => {
    if (deviceType !== undefined) {
      getModel(deviceType).then(setModel);
    }
  }, [deviceType]);

  const options = useMemo(() => {
    return model.map(i => ({ label: i.name, value: i.name }));
  }, [model]);

  const [searchValue, setSearchValue] = useState<string>();

  const onSearch = debounce((value: string) => {
    setSearchValue(value);
  }, 10);

  const onBlur = () => {
    if (searchValue) {
      form.setFieldsValue({
        modelName: searchValue,
      });
    }
  };

  const onSubmit = (value: Omit<BsaDeviceTemplateRequest, 'bsaId'>) => {
    if (id) {
      setLoading(true);
      createPackDevice({
        ...value,
        bsaId: Number(id),
      }).then(() => {
        // 更新外部
        updateFn?.();
        setLoading(false);
      });
    }
  };

  const onRefresh = () => {
    if (id) {
      packStatusCheck(Number(id)).then(res => {
        if (res.status !== ProcessStatusEnum.GENERATING) {
          updateFn?.();
        }
      });
    }
  };

  /** init form */

  const onPrevious = () => {
    if (Array.isArray(typeList) && foucsType) {
      const type = getPrevious(foucsType, typeList);
      if (type) {
        changeType?.(type);
      }
    }
  };

  const onNext = () => {
    const type = getNext(foucsType!, typeList ?? [], currentType);
    if (type) {
      changeType?.(type);
    }
  };

  const onSaveDraft = () => {
    const value: Partial<Omit<BsaDeviceTemplateRequest, 'bsaId'>> = form.getFieldsValue();
    saveDraft({
      bsaId: Number(id),
      content: JSON.stringify(value),
    }).then(() => {
      Modal.success({
        content: '保存成功',
      });
    });
  };

  const onFinish = () => {
    if (id) {
      if (disabled) {
        onNext();
      } else {
        if (isComplete) {
          onNext();
        } else {
          if (currentType === BsaType.PACK_DEVICE_COMPLETED) {
            submitPackDevice(id).then(() => {
              // 更新
              updateFn?.();
            });
          } else if (currentType === BsaType.PACK_DEVICE_CREATE) {
            Modal.warning({
              title: '请先生成电池组',
            });
          } else {
            Modal.warning({
              title: '请先等待电池组生成完毕',
            });
          }
        }
      }
    }
  };

  return (
    <Spin spinning={loading}>
      <Wrapper routes={[...(routesContext?.routes ?? []), ...routes]}>
        <div className={classNames('page__content', styles.content)} style={{ minHeight: 'calc(100vh - 128px)' }}>
          <BsaPageHeader
            title="电池组设置"
            extraContent={
              <Space>
                <Button type="primary" onClick={onPrevious}>
                  上一步
                </Button>
                <Button type="primary" onClick={onFinish}>
                  下一步
                </Button>
                {!isInit && status !== BSAStatus.INVALID && (
                  <Button type="primary" onClick={onSaveDraft}>
                    存草稿
                  </Button>
                )}
              </Space>
            }
          >
            <BsaSteps typeList={typeList} foucsType={foucsType} />
          </BsaPageHeader>
          {!isInit ? (
            <>
              {status !== BSAStatus.INVALID && (
                <div>
                  <div className={styles.title}>电池组型号</div>
                  <Form form={form} layout="vertical" {...formLayout} onFinish={onSubmit}>
                    <Row>
                      <Col span={6}>
                        <Form.Item
                          name="deviceTypeId"
                          label="所属2级类目"
                          rules={[{ required: true, message: '请选择所属类目' }]}
                        >
                          <Select
                            onChange={(e: number) => {
                              setDeviceType(e);
                            }}
                            placeholder="请选择"
                          >
                            {(deviceTypes ?? []).map(i => (
                              <Select.Option key={i.id} value={i.id}>
                                {i.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="modelName"
                          label="型号"
                          rules={[{ required: true, message: '请选择所属型号' }]}
                        >
                          <Select
                            disabled={deviceType === undefined}
                            style={{ width: '100%' }}
                            showSearch
                            placeholder="请输入"
                            onSearch={onSearch}
                            onBlur={onBlur}
                            optionFilterProp="label"
                            options={options}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item label=" ">
                          <Button type="primary" htmlType="submit">
                            批量生成电池组
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                </div>
              )}
            </>
          ) : (
            <>
              {status !== BSAStatus.INVALID && (
                <Form
                  layout="vertical"
                  {...formLayout}
                  onFinish={(v: SerachParams) => {
                    setSearch(v);
                  }}
                >
                  <Row>
                    <Col span={4}>
                      <Form.Item name="pcsSequence" label="PCS编号">
                        <Input placeholder="请输入" />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item name="rackSequence" label="电池簇编号">
                        <Input placeholder="请输入" />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item label=" ">
                        <Space>
                          {/* TODO 临时方案 */}
                          <Button type="primary" onClick={onRefresh}>
                            刷新
                          </Button>
                          {currentType !== BsaType.PACK_DEVICE_CREATED ? null : (
                            <>
                              <Button type="primary" htmlType="submit">
                                查询
                              </Button>

                              <Button type="primary">
                                <a
                                  target="_blank"
                                  href={combineURL(window.IOTPLATFORMORIGIN, `/device/manage/device`)}
                                  rel="noreferrer"
                                >
                                  前往修改电池组信息
                                </a>
                              </Button>
                            </>
                          )}
                        </Space>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              )}

              <div className={styles.title}>电池组列表</div>
              <Table
                loading={tableLoading}
                columns={columns}
                rowKey="deviceId"
                dataSource={packs}
                rowClassName={(record: PackDevice) => {
                  return record.deviceStatus === DeviceStatus.INVALID ? 'device-invalid' : '';
                }}
              />
              <div className={classNames('page__content__footer', styles.footer)}>
                <Paging pagingInfo={pagingInfo} />
              </div>
            </>
          )}
        </div>
      </Wrapper>
    </Spin>
  );
};

export default BsaPack;
